import { Dev } from '@/ui/pages/root/dev/Dev';
import { Docs } from '@/ui/pages/root/docs/Docs';
import { Login } from '@/ui/pages/root/login/Login';

import {
  authLoader,
  loginLoader,
  logoutLoader,
  rootIndexLoader,
} from './rootLoaders';

export const rootRoutes = [
  {
    index: true,
    loader: rootIndexLoader,
  },
  {
    path: 'login',
    loader: loginLoader,
    element: <Login />,
  },
  {
    path: 'logout',
    loader: logoutLoader,
    element: <p>...</p>,
  },
  {
    path: 'oauth/callback',
    loader: authLoader,
    element: <p>...</p>,
  },
  {
    path: 'dev',
    element: <Dev />,
  },
  {
    path: 'docs',
    element: <Docs />,
  },
];
